module.exports = __webpack_public_path__ + "static/media/Illus-Pickup_2@3x.b307aef0.png";